import { api } from '@/config/api';

export interface BookingSiteSettings {
  companyUid: string;
  isEnabled: boolean;
  kioskPhones: string[];
  sendConfirmation: boolean;
  sendReminders: boolean;
  reminderHoursBefore: number[];
  otpTemplateUid?: string;
  confirmationTemplateUid?: string;
  reminderTemplateUid?: string;
}

const BASE = '/slighter_crm/booking-site';

export const bookingSiteService = {
  getSettings: async (): Promise<BookingSiteSettings> => (await api.get(`${BASE}/settings`)).data,
  updateSettings: async (patch: Partial<BookingSiteSettings>): Promise<BookingSiteSettings> =>
    (await api.put(`${BASE}/settings`, patch)).data,
};
